module.exports = __webpack_public_path__ + "img/clear.325f1479.png";